module.exports = __webpack_public_path__ + "static/media/is.3039e314.svg";